import { Link } from 'react-router-dom';
import { articleTeasers } from '@/mocks/articles';

export default function ArticleCards() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-600 mb-3">
              Learning Hub
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
              Superbuy Spreadsheet <span className="italic text-accent-500">Guides & Articles</span>
            </h2>
          </div>
          <p className="text-foreground-600 text-sm max-w-md leading-relaxed">
            Explore our collection of in-depth guides designed to help you master every aspect of using Superbuy Spreadsheet resources effectively.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {articleTeasers.map((article, index) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-2xl overflow-hidden hover:scale-[1.02] transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              <div className="p-5">
                <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-3">
                  {article.tag}
                </span>
                <h3 className="text-foreground-900 font-heading font-semibold text-base md:text-lg leading-snug mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                  {article.description}
                </p>
                <div className="flex items-center gap-2 mt-4 text-primary-500 text-sm font-semibold">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform duration-200"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}